module.exports = __webpack_public_path__ + "img/index_03_pic@2x.685876a6.png";